import React from 'react'
import { captureError } from './otel'

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  State
> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    captureError(error)
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}
